"use strict";
/**
 * InkStep Audio Asset shared types — pronunciation audio for graphemes and words.
 *
 * WP-070: Audio Pronunciation Content (pure-phoneme, no schwa).
 * Audio assets are stored as MP3 in MinIO and metadata is tracked in the
 * `inkstep_audio_assets` table. Each asset goes through a human quality
 * review (pending → approved/rejected) before being used in student-facing
 * content.
 */
Object.defineProperty(exports, "__esModule", { value: true });
